import moment from "moment";

import { parseISO, differenceInSeconds } from "date-fns";

export function findTimeDifference(paternosterTimer, dryTunnelExitTime) {
  // Parse the input timestamps
  const paternosterDate = parseISO(paternosterTimer);
  const dryTunnelDate = parseISO(dryTunnelExitTime);

  // Check if the dates were parsed correctly
  if (isNaN(paternosterDate) || isNaN(dryTunnelDate)) {
    console.error("Error parsing dates:", { paternosterDate, dryTunnelDate });
    return "Invalid date format";
  }

  // Calculate the difference in seconds
  const totalSeconds = differenceInSeconds(paternosterDate, dryTunnelDate);

  // Check if the difference calculation is correct
  if (isNaN(totalSeconds)) {
    console.error("Error calculating difference:", { totalSeconds });
    return "Error calculating difference";
  }

  // Convert the difference into hours, minutes, and seconds
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  // Format the result as HH:MM:SS
  const formattedDifference = `${String(hours).padStart(2, "0")}:${String(
    minutes
  ).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;

  return formattedDifference;
}

export const customDateConvert = (time, format) => {
  // console.log(time, format);
  // console.log(Date(time));
  return moment.utc(time).format(format);
};

export const convertToHHmmss = (dates, format) => {
  if (!dates) return [];
  return dates.map((date) => {
    const parsedDate = moment.utc(date, "MM-DD-YYYYTHH:mm:ss");
    // console.log(`Original date: ${date}, Parsed date: ${parsedDate.format()}`);
    return parsedDate.isValid() ? parsedDate.format(format) : "Invalid Date";
  });
};

export const lightenHexToRgba = (hex) => {
  let r = 0,
    g = 0,
    b = 0;
  r = parseInt(hex[1] + hex[2], 16);
  g = parseInt(hex[3] + hex[4], 16);
  b = parseInt(hex[5] + hex[6], 16);
  return `rgba(${r},${g},${b},0.1)`;
};
